import { Message, useMessage } from '@messageformat/react';
import { Tile } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import { ReactElement } from 'react';
import { formatNumberWithoutDecimals } from '../../utils';

interface Props {
  messageId: string;
  costArray: string[];
  total: number;
}

const ExampleCostItems = (props: Props): ReactElement => {
  const { messageId, costArray, total } = props;
  const itemsArray = useMessage(messageId);
  return (
    <div className="investoracademy-example-costs-container">
      <Tile
        className="investoracademy-example-costs-tile investoracademy-flex-column-center"
        wrapContent={false}
      >
        <h3
          className="opds-styles-v1-text-title-small-strong"
          style={{ textAlign: 'center', paddingTop: space.small }}
        >
          <Message id="course4.example_costs_title" />
        </h3>
        <div className="investoracademy-divider-line" />
        <ul className="investoracademy-example-costs-row">
          {Object.keys(itemsArray).map((item, index) => {
            return (
              <li
                key={item}
                className="investoracademy-example-cost-list investoracademy-flex-center-stretch"
              >
                <span
                  className="opds-styles-v1-text-body-medium"
                  style={{ flex: '1 0 0' }}
                >
                  <Message id={`${messageId}.${item}`} />
                </span>
                <span
                  className="opds-styles-v1-text-hero-small"
                  style={{ textAlign: 'right' }}
                >
                  {formatNumberWithoutDecimals(Number(costArray[index]))} €
                </span>
              </li>
            );
          })}
        </ul>
        <div className="investoracademy-divider-line" />
        <div className="investoracademy-example-cost-list investoracademy-flex-center-stretch">
          <span className="investoracademy-total-text investoracademy-textHighlight-small">
            <Message id="course4.total" />
          </span>
          <span
            className="investoracademy-number-highlightLarge"
            style={{ textAlign: 'right' }}
          >
            {formatNumberWithoutDecimals(total)} €
          </span>
        </div>
      </Tile>
    </div>
  );
};

export default ExampleCostItems;
